const modalTestIDs = {
  modalHeader: 'modal-header',
  modalActionButton: 'modal-action-button',

  whatsNewModal: 'whats-new-modal',

  pinModal: 'pin-modal',
  pinInputTitle: 'pin-input-title',
  pinInputElement: 'pin-input-element',
  reportInfoModal: 'report-info-modal',
  reportInfoModalHeader: 'report-info-modal-header',
  reportInfoModalBody: 'report-info-modal-body',
  modalGoBackButton: 'go-back-button',
};

export default modalTestIDs;
